export class NotfDateRangeApi
{
    since: string | null;
    until: string | null;
}
